// extracted by mini-css-extract-plugin
module.exports = {"ourResearchSection":"textWrapAroundimg-module--ourResearchSection--1uosB"};